import styled from 'styled-components';

export const ToggleHeaderContainer = styled.div`
    width: 100%;
    margin: 2.5rem 0 1rem 0;
`;

export const ToggleHeaderAction = styled.div`
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
`;
